import CompanyRepository from "../../Repository/CompanyRepository";
import { Toast } from "../components/Toast";
import { clearCompany } from "./companySlice";

export const updateCompany = async (arg, dispatch) => {
  try {
    let { data } = await CompanyRepository.companyModel({
      request: {
        method: "updateCompany",
        data: {
          company: {
            ...arg,
          },
        },
      },
    });
    if (data.response.status.statusCode == 200) {
      Toast("success", "Added Successfully");
    } else {
      Toast("error", "Not Added");
      dispatch(clearCompany());
    }
  } catch (err) {
    console.log("err:", err);
    Toast("error", "Error");
    dispatch(clearCompany());
  }
};
